import { render } from "./ModalGuardarComidas.vue?vue&type=template&id=66da7a15&scoped=true"
import script from "./ModalGuardarComidas.vue?vue&type=script&lang=js"
export * from "./ModalGuardarComidas.vue?vue&type=script&lang=js"

import "./ModalGuardarComidas.vue?vue&type=style&index=0&id=66da7a15&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66da7a15"]])

export default __exports__